var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNotFound = function SvgNotFound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 739 457"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49, 144, 255)",
    d: "M345.51 4.65h-2.02l-3.58 25.8h9.19l-3.59-25.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49, 144, 255)",
    d: "M349.1 4.65a4.62 4.62 0 0 1-4.6 4.66 4.62 4.62 0 0 1-4.6-4.66A4.62 4.62 0 0 1 344.5 0c2.54 0 4.6 2.08 4.6 4.65Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#not-found_svg__a)",
    d: "M346.12 9a2.57 2.57 0 0 0-2.14-.5l-1.24 19.8h-1.4l2.02-19.59c-.3.15-.48.3-.48.3l-2.78 20.07 8.76-.32L346.12 9Z",
    opacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49, 144, 255)",
    d: "M344.5 73.21c18.3 0 33.15-10.6 33.15-23.7 0-13.08-14.84-23.7-33.15-23.7-18.3 0-33.15 10.62-33.15 23.7 0 13.1 14.84 23.7 33.15 23.7Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#not-found_svg__b)",
    fillOpacity: 0.5,
    d: "M344.5 25.8c-18.31 0-33.15 10.62-33.15 23.7 0 5.6 2.73 10.75 7.26 14.8.17-5.4.94-10.8 2.64-15.93 1.94-5.83 5.12-11.3 9.6-15.46a26.83 26.83 0 0 1 14.95-7.08l-1.3-.02Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#not-found_svg__c)",
    d: "M289.64 47.94c-12.56 5.35-19.18 10.18-19.18 10.18l74.04-3.42 74.04 3.42s-6.62-4.83-19.18-10.18a139.88 139.88 0 0 0-109.72 0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234, 244, 255)",
    d: "M289.64 47.94c-12.56 5.35-19.18 10.18-19.18 10.18l9.77-.45c3.7-1.64 8.54-3.7 14.66-6.15 26.82-13.54 45.42-14.68 48.96-14.77-18.45.08-36.88 3.8-54.21 11.19Z",
    opacity: 0.3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49, 144, 255)",
    d: "M424 66.6c0-12.84-35.6-23.24-79.5-23.24S265 53.76 265 66.6v6.15h2.82c9.23 9.85 40.06 17.1 76.68 17.1 36.62 0 67.45-7.25 76.68-17.1H424V66.6Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#not-found_svg__d)",
    d: "M344.5 96c43.9 0 79.5-10.4 79.5-23.25 0-12.84-35.6-23.24-79.5-23.24S265 59.9 265 72.75C265 85.6 300.6 96 344.5 96Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M304.15 91.05a27.12 27.12 0 0 1-4.62-2.77c-2.73-2.04-5.14-4.98-5.22-8.4 0-.46.02-.91.1-1.36a102.91 102.91 0 0 1-17.85-9.4 16.15 16.15 0 0 0-4.32 5.86c5.52 8.39 20.55 13.38 31.91 16.07Zm4.85-32.5a59.39 59.39 0 0 0 4.82 5.36c9.44-2.92 20.67-4.18 30.8-4.64V57c-14.19-.75-26.11.14-35.62 1.56Zm37.34-1.45v2.1c8.14-.3 15.42-.1 20.26.13a213.04 213.04 0 0 0-20.26-2.23Zm-39.27 1.75a138.85 138.85 0 0 0-18.44 4.26c.84.17 1.47.57 1.66 1.2.36 1.17-.9 2.6-2.81 3.19-1.9.6-3.74.14-4.1-1.02-.16-.55.04-1.16.5-1.7-2.08.85-4.09 1.9-5.88 3.2 2.67 1.8 9.46 6.12 16.87 8.84.97-2.49 3.06-4.6 5.22-6.3 3.27-2.55 7.45-4.55 12.1-6.12a62.73 62.73 0 0 1-5.12-5.55Zm-13.64 5.95c-.95.2-1.83-.1-1.96-.67-.12-.57.55-1.22 1.5-1.43.96-.2 1.84.09 1.96.67.13.57-.54 1.21-1.5 1.43Z",
    opacity: 0.25
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49, 144, 255)",
    d: "m376.56 84-.06-.44c16-2.24 36-12.84 43.92-20.94l.32.31c-7.98 8.17-28.08 18.83-44.18 21.08Zm-32.96 0-.12-.43c14.5-4.32 34.75-15.63 44.14-33.3l.4.22C378.55 68.27 358.17 79.66 343.6 84Zm-31.2 0c-16.1-2.24-36.2-12.9-44.19-21.06l.32-.31c7.93 8.1 27.92 18.7 43.93 20.93l-.07.45Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49, 144, 255)",
    d: "M345.35 84c-14.58-4.34-34.96-15.73-44.4-33.51l.38-.22c9.4 17.67 29.65 28.98 44.15 33.3l-.13.44Zm-.65-35.5h-.45v21.65h.45V48.5Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234, 244, 255)",
    d: "M344.5 92.65c24.6 0 44.54-5.83 44.54-13.03 0-7.19-19.94-13.02-44.54-13.02-24.6 0-44.54 5.83-44.54 13.02 0 7.2 19.94 13.03 44.54 13.03Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M324.26 69.58c-10.18 1.54-15.98 4.04-18.85 5.66 8.96 8.78 21.8 8.7 25.4 3.45-3.88-2.51-5.73-6.54-6.55-9.11Z",
    opacity: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49, 144, 255)",
    d: "M344.5 93.66c16.13 0 29.21-3.83 29.21-8.54 0-4.72-13.07-8.54-29.21-8.54-16.13 0-29.21 3.82-29.21 8.54 0 4.71 13.08 8.54 29.21 8.54Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#not-found_svg__e)",
    fillOpacity: 0.5,
    d: "M344.5 92.65c-14.36-2.98-14.92-14.85-14.92-14.87-5.36.92-9.61 2.35-12.04 4.04 5.67 8.14 12.04 9.82 26.96 10.83Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1F2F2",
    d: "M344.5 86.96c-6.9 0-12.51 1.65-12.51 3.67s5.6 3.66 12.51 3.66 12.51-1.64 12.51-3.66c0-2.03-5.6-3.67-12.51-3.67Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#not-found_svg__f)",
    d: "M207.82 168.61C109.52 187.6 56.65 366.1 61.28 429.67c126.02 14.18 538.56 74.39 582.3-47.89C610.85 290 752.83 267.06 737.9 168.61c-14.93-98.44-354.03-44.35-378.7-70.48C358 87.5 355.2 87 343.75 87c-16.88 0-13.08 6.3-10.4 18.87 11.22 52.38 266.13 40.66 249.38 90.5-45.3 134.77-252.03-51.49-374.91-27.76Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    d: "M352.5 96c0 1 2 5.5 8 7.5M375 112c13 1.83 41.3 5.6 50.5 6M346 93.5c0 5.5 5.5 13 19 16.5m-23.5-11.5c.33 2.5 3 8.4 11 12"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234, 244, 255)",
    d: "M637.03 191.96c-18.97-.82-33.92-36.39-39.03-54.07 13-13.94 41.87-19.8 47.55-17.35 3.73 36.43 38.45 44.9 38.45 50 0 5.1-23.27 22.44-46.97 21.42Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49, 144, 255)",
    d: "M619.75 157.91H618l.8 2.09h2.44l.76-3.26-1.46-3.74-.8 4.91Z",
    opacity: 0.2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49, 144, 255)",
    fillOpacity: 0.2,
    d: "M638.27 178.43c-6.76 5.6-16.96 1.86-21.27-.48 9.15 12.02 17.95 14.5 21.27 13.99 2.81-6.84 6.76-19.12 0-13.51Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(49, 144, 255)",
    d: "M641.45 132.03c-5.74-.55-26.35 8.1-32.45 12.45 1.24 2.5 5.49 10.2 5.49 8.19s20.71-11.25 29.51-13.99c-.7-.46-1.77-3.12-2.55-6.66Zm3.05 8.97c-5.59 1.1-16.62 7.06-22.5 11.58 1.2 2.61 1.87 4.83 2.2 4.36.33-.48 14.31-8.62 22.8-11.47-1.23-2.13-1.43-3.16-2.5-4.47Zm-21.75 22.91H621l.8 2.09h2.44l.76-3.26-1.46-3.74-.8 4.91ZM647.5 148c-5.59 1.03-16.62 6.62-22.5 10.85 1.2 2.46 1.87 4.53 2.2 4.09.33-.45 14.31-8.07 22.8-10.75-1.23-2-1.43-2.96-2.5-4.19Zm-20.75 21.91H625l.8 2.09h2.44l.76-3.26-1.46-3.74-.8 4.91ZM651.5 153c-5.59 1.1-16.62 7.06-22.5 11.58 1.2 2.61 1.87 4.83 2.2 4.36.33-.48 14.31-8.62 22.8-11.47-1.23-2.13-1.43-3.16-2.5-4.47Z",
    opacity: 0.2
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#C5E0FF",
    d: "M524.27 103.5c-1.33 1.6 2.82 11.61 1.3 15.5 15.5-2.8 15.23-13 15.43-17.67-5.69.28-11.36-4.34-16.73 2.17Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234, 244, 255)",
    d: "M528.58 99.25c9.8-2.18 29.5 6.68 34.51 14.94-4.75 8.84-18.69 15.75-21.92 15.28-6.84-17.93-25.72-17.47-26.42-20.05 2.22-4.63 7.3-8.72 13.83-10.17Zm-83.38 20.23c-9.1 2.55-15.3-4.91-19.2-9.23 4.2-1.34 4.67-3.36 8.82-1.5 3.54 5.13 15.62.6 19.96 0 .86 2.68-.47 8.18-9.58 10.73Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeDasharray: "2 5 10 5",
    strokeLinecap: "round",
    d: "m393 110 30.5 2"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeDasharray: "2 5 10 5 20 5 10 5",
    strokeLinecap: "round",
    d: "M389 119.5c24.17 3 73.1 9 75.5 9"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    d: "m455.5 120 19 1.5m-18-7.5 12.5.5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeDasharray: "10 5 20 5",
    strokeLinecap: "round",
    d: "m496 115 22 1"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    d: "M486 122s17.48.9 27 2c8.45.97 19.5 2.5 19.5 2.5"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeDasharray: "2 5 10 5 20 5 10 5",
    strokeLinecap: "round",
    d: "M504.5 134c23.5 3.5 71.4 11.6 75 16"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    d: "M554 129c11 0 35 4 37.5 6m-26-16s13.14.17 21.5 1c8.85.88 22.5 3.5 22.5 3.5M657 134c25 7 59 29.8 17 97m-10.5-35c1 8.5-4.8 23.5-12 33.5m-14.5-23c0 11-16.7 25.4-19.5 27"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeDasharray: "2 5 10 5 20 5 10 5",
    strokeLinecap: "round",
    d: "M644.5 240c-12.5 18.67-42 58.5-54 69.5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#not-found_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M207.9 334.74h-26.78v-30.82h-63.94v30.82H89.82l76.04-114.34h-69.7L10.62 344.24v43.2h104.55V422h65.95v-34.56h26.78v-52.7Zm129.58 91.87c53.28 0 91.3-38.6 91.3-105.41 0-66.82-38.02-105.4-91.3-105.4-53.28 0-91.3 38.58-91.3 105.4 0 66.82 38.02 105.4 91.3 105.4Zm0-54.43c-13.25 0-23.04-12.1-23.04-50.98 0-38.88 9.8-50.98 23.04-50.98 13.25 0 23.04 12.1 23.04 50.98 0 38.88-9.8 50.98-23.04 50.98Zm332.46-37.44h-26.78v-30.82h-63.94v30.82h-27.36L627.9 220.4h-69.7l-85.53 123.84v43.2h104.55V422h65.95v-34.56h26.78v-52.7Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "not-found_svg__a",
    x1: 344.47,
    x2: 336.93,
    y1: 7.49,
    y2: 17.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "rgb(146, 226, 251)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "not-found_svg__b",
    x1: 328.55,
    x2: 319.32,
    y1: 24.04,
    y2: 50.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "rgb(146, 226, 251)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "not-found_svg__c",
    x1: 372.88,
    x2: 327.54,
    y1: 37.8,
    y2: 108.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgb(103, 191, 254)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "rgb(146, 226, 251)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "not-found_svg__d",
    x1: 374.98,
    x2: 270.3,
    y1: 51.83,
    y2: 132.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgb(103, 191, 254)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "rgb(146, 226, 251)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "not-found_svg__e",
    x1: 331,
    x2: 329.08,
    y1: 77.09,
    y2: 88.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "rgb(146, 226, 251)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "not-found_svg__f",
    x1: 422.04,
    x2: 372.52,
    y1: 70.2,
    y2: 340.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgb(103, 191, 254)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "rgb(146, 226, 251)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "not-found_svg__g",
    width: 679.32,
    height: 230.82,
    x: 0.62,
    y: 209.79,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.180392 0 0 0 0 0.356863 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
};
export default SvgNotFound;